import React from 'react';

import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const ReactHookFormCheckboxButtonGroup = ({
    control,
    disabled,
    items,
    name,
    row,
}) => (
    <Controller
        control={control}
        name={name}
        render={({
            field: { onChange, value: selectedValue },
            fieldState: { error },
        }) => (
            <FormControl error={Boolean(error)}>
                <FormGroup row={row}>
                    {items.map(
                        ({ label, value, hidden = false }, index) =>
                            !hidden && (
                                <FormControlLabel
                                    key={`checkbox-field-${value}-${index}`}
                                    control={
                                        <Checkbox
                                            checked={
                                                selectedValue[value] == true
                                            }
                                            onChange={(e) => {
                                                const newValue = Object.assign(
                                                    {},
                                                    selectedValue,
                                                    {
                                                        [value]:
                                                            e.target.checked,
                                                    },
                                                );

                                                onChange(newValue);
                                            }}
                                            value={value}
                                        />
                                    }
                                    disabled={disabled}
                                    label={label}
                                />
                            ),
                    )}{' '}
                </FormGroup>
                {Boolean(error) && (
                    <FormHelperText>{error?.message}</FormHelperText>
                )}
            </FormControl>
        )}
    />
);

ReactHookFormCheckboxButtonGroup.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    items: PropTypes.array,
    name: PropTypes.string,
    row: PropTypes.bool,
};

export default ReactHookFormCheckboxButtonGroup;
